import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Container } from './WeddingGuestPage.styles';
import EnterFullName from '../../components/WeddingGuest/EnterFullName/EnterFullName';
import SelectInfo from '../../components/WeddingGuest/SelectInfo/SelectInfo';
import HowToSpell from '../../components/WeddingGuest/HowToSpell/HowToSpell';
import MultipleGuest from '../../components/WeddingGuest/MultipleGuest/MultipleGuest';
import Confirmation from '../../components/WeddingGuest/Confirmation/Confirmation';
import Restrictions from '../../components/WeddingGuest/Restrictions/Restrictions';
import SeeYaSoon from '../../components/WeddingGuest/SeeYaSoon/SeeYaSoon';
import Attending from '../../components/Attending/Attending';
import { useDispatch } from 'react-redux';
import { fetchRSVPDetails } from '../../store/slice/rsvp/asyncThunks';
import RsvpSubmitted from '../../components/WeddingGuest/RsvpSubmitted/RsvpSubmitted';

const WeddingGuestPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  let [searchParams] = useSearchParams();
  const step = searchParams.get('step');
  const rsvpKey = searchParams.get('key');

  useEffect(() => {
    if (rsvpKey) {
      dispatch(fetchRSVPDetails({ key: rsvpKey }));
    }
  }, [dispatch, rsvpKey]);

  return (
    <Container>
      {!step && <EnterFullName rsvpKey={rsvpKey} />}
      {step === 'SELECTINFO' && <SelectInfo rsvpKey={rsvpKey} />}
      {step === 'MULTIPLEGUEST' && <MultipleGuest rsvpKey={rsvpKey} />}
      {step === 'HOWTOSPELL' && <HowToSpell rsvpKey={rsvpKey} />}
      {step === 'ATTENDING' && <Attending rsvpKey={rsvpKey} />}
      {step === 'CONFIRMATION' && <Confirmation rsvpKey={rsvpKey} />}
      {step === 'RESTRICTIONS' && <Restrictions rsvpKey={rsvpKey} />}
      {step === 'SEEYASOON' && <SeeYaSoon rsvpKey={rsvpKey} />}
      {step === 'SUBMITTED' && <RsvpSubmitted rsvpKey={rsvpKey} />}
    </Container>
  );
};

export default WeddingGuestPage;
